import React, { createContext, useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { useRecentWorkArtifact } from '@atlassian/recent-work-client/flight-deck';
import { LOCAL_EVENT_TYPE_MESSAGES, messageForEventType, translatedStringsToMessageDescriptors } from './utils';
export var RecentWorkEventTypeMessagesContext = /*#__PURE__*/createContext({
  eventTypeMessages: LOCAL_EVENT_TYPE_MESSAGES
});
export function RecentWorkEventTypeMessagesProvider(_ref) {
  var children = _ref.children,
    locale = _ref.locale;
  var artifact = useRecentWorkArtifact(locale);
  var providerValue = useMemo(function () {
    return {
      eventTypeMessages: LOCAL_EVENT_TYPE_MESSAGES,
      eventTypeMessagesTranslated: translatedStringsToMessageDescriptors(artifact === null || artifact === void 0 ? void 0 : artifact.localization.eventTypes)
    };
  }, [artifact]);
  return /*#__PURE__*/React.createElement(RecentWorkEventTypeMessagesContext.Provider, {
    value: providerValue
  }, children);
}
export function WrappedRecentWorkEventTypeMessagesProvider(_ref2) {
  var children = _ref2.children;
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  return /*#__PURE__*/React.createElement(RecentWorkEventTypeMessagesProvider, {
    locale: locale
  }, children);
}
export var useEventTypeMessagesContext = function useEventTypeMessagesContext() {
  return React.useContext(RecentWorkEventTypeMessagesContext);
};
export function useEventTypeMessage(eventType) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _useEventTypeMessages = useEventTypeMessagesContext(),
    eventTypeMessages = _useEventTypeMessages.eventTypeMessages,
    translatedMessagesMap = _useEventTypeMessages.eventTypeMessagesTranslated;
  return messageForEventType(eventType, translatedMessagesMap || eventTypeMessages, options);
}